import platforms from 'maps/social-platforms';

import { ReactComponent as IconFacebook } from 'icons/social/facebook.svg';
import { ReactComponent as IconTwitter } from 'icons/social/twitter.svg';
import { ReactComponent as IconInstagram } from 'icons/social/instagram.svg';
import { shape, number } from 'prop-types';

export default PlatformIcon;

/**
 *
 * @param {object} props React props
 * @param {object} props.platform Platform metadata
 */
function PlatformIcon(props) {
  const { platform } = props;

  switch (platform.id) {
    case platforms.facebook.id:
      return <IconFacebook />;
    case platforms.instagram.id:
      return <IconInstagram />;
    case platforms.twitter.id:
      return <IconTwitter />;
    default:
      return null;
  }
}

PlatformIcon.propTypes = {
  platform: shape({
    id: number.isRequired,
  }).isRequired,
};
